export const PRIORITY = {
	HIGH: 0,
	LOW: 2,
};

export const RETRY_DELAY = 300;
export const RETRY_FACTOR = 1;
